import React, {Component} from 'react';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import firebase from 'firebase';
import secondaryApp from '../BD/secondaryApp';
import { sendLog } from '../../util'

const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'	
  }
};


class ModalUsuarios extends Component{
	
		constructor(props){
			
			super(props);
			this.state={
				isActive:false,
				perfiles:[]	,
				sAdmin:false,
				adminCheck:false,
				adminEstado:false,
				checkAdmin:false
			}
			this.passwordAdmin=''
			//Referencia al nodo de usuarios de firebase
			this.UsuarioAcacyaRef=database.ref().child('Usuarios_Acacya');
			
			//Referncia al nodo de perfiles de firebase
			this.PerfilesRef=database.ref().child('Perfiles');
			
			//Funcion para crear items para los select  de tipos de perfil
			this.MakeItems=this.MakeItems.bind(this);
			
			//Función para el envio del formulario
			this.handleSubmit=this.handleSubmit.bind(this);
			
			this.toggleModal=this.toggleModal.bind(this);
		}
	
		
		componentDidMount(){
			
			this.PerfilesRef.on('value',this.gotData,this.errData);
			this.checkSAdmin();
		}
	
		componentWillMount(){
			
			Modal.setAppElement('body');
			
		}

		checkSAdmin = () => {
			let id = firebase.auth().currentUser.uid;
			firebase.database().ref("superAdmin").once("value").then(rows => {
				rows.forEach( element => {
					let data = element.val();
					data.key = element.key;
					if (data.key === id) {
						this.setState({checkAdmin:true})
					}
				})
			})
		}

		handleInputChange = (event) => {
			const target = event.target;
			const value = target.type === 'checkbox' ? target.checked : target.value;
			const name = target.name;
			this.setState({
				[name]: value
			});
		}
	
		gotData=(data)=>{
			
			let newPerfil=[];
			
			const perfilesdata=data.val();
			
			//Si el nodo de perfiles no esta vacio
			if(perfilesdata!=null){
				
				const keys = Object.keys(perfilesdata);
				
				for (let i = 0; i < keys.length; i++) {
					const k = keys[i];
					
					newPerfil.push({
						key:k,
						nombre:perfilesdata[k].nombre				  
					});				
				}
				 this.setState({perfiles: newPerfil});			
			}		
		}
		errData=(err)=>{		
			console.log(err)
		}
	
	
	
		toggleModal(){			
			this.setState({				
				isActive:!this.state.isActive
			});		
		}
	
		//Retorna las opciones para llenar el select de los perfiles
		MakeItems(x){
			return <option>{x.nombre}</option>;		
		}

		createAdmin = (nombre, correo, perfil, estado, password) => {

				secondaryApp.auth().createUserWithEmailAndPassword(correo,password)
			.then(user => {
				
					firebase.database().ref().child('superAdmin/' + user.uid).update({
						
							nombre:nombre,
							correo:correo,
							perfil:perfil,
							estado:estado		
					})	
						
					Alert.success('Datos ingresados con exito', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000
							
					});
						
					secondaryApp.auth().signOut();
					sendLog({ tipo: 'usuario_nuevo', informacion_extra: {usuario: user.uid}});
					this.toggleModal();
			})
			.catch(error =>{
					let msj='Error al ingresar usuario';
				
					if(error.code==='auth/email-already-in-use'){	
						msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
					}
					else if(error.code==='auth/invalid-email'){					
						msj='Dirección de correo electronico no valida.';					
					}
					
					else if(error.code==='auth/weak-password'){
						
						msj='La contraseña ingresada no es demasiado fuerte.';
							
					}

					Alert.error(msj, {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
					});
		
			
			});
		}
		
		//Función para el envio del formulario
		handleSubmit(event){
			event.preventDefault();
			
			let {sAdmin} = this.state;
			let adminEstado = false;
			let nombre=this.nombreUsuario.value;
			let correo=this.correoUsuario.value;
			let password=this.passwordUsuario.value;
			let confpassword=this.confpasswordUsuario.value;
			let adminpass=this.passwordAdmin.value;
			let perfil=this.perfilUsuario.value;
			let estado=this.estadoUsuario.value;
			
			if(password===confpassword){
				
				if (sAdmin) {
					firebase.database().ref('AdminPass').once('value').then(snapA => {
						snapA.forEach(r => {
							let data = r.val();
							if (data.password === adminpass) {
								adminEstado = true;
								this.createAdmin(nombre, correo, perfil, estado, password);
							}
						})
					})
					if (adminEstado === false) {
						Alert.warning('Contraseña de Administrador Incorrecta', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:3000
							
					});
					}
					
				}
				else{
					
					secondaryApp.auth().createUserWithEmailAndPassword(correo,password)
					.then(user => {
						
							
							this.UsuarioAcacyaRef.child(user.uid).update({
								
									nombre:nombre,
									correo:correo,
									perfil:perfil,
									estado:estado				
							})	
								
							Alert.success('Datos ingresados con exito', {
									effect: 'genie',
									position: 'bottom-right',
									timeout:2000
									
							});
								
							secondaryApp.auth().signOut();
							sendLog({ tipo: 'usuario_nuevo', informacion_extra: {usuario: user.uid}});
							this.toggleModal();
					})
					.catch(error =>{
				
							let msj='Error al ingresar usuario';
						
							if(error.code==='auth/email-already-in-use'){	
								msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
							}
							else if(error.code==='auth/invalid-email'){					
								msj='Dirección de correo electronico no valida.';					
							}
							
							else if(error.code==='auth/weak-password'){
								
								msj='La contraseña ingresada no es demasiado fuerte.';
									
							}

							Alert.error(msj, {
									effect: 'genie',
									position: 'bottom-right',
									timeout:2000			
							});
				
					
					});
				}		
			}
			else{
				
					Alert.error('Las contraseñas ingresadas no coinciden', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000
						
					});
			}
			
			
			
		}
		
	
	
		render(){
			
			let {checkAdmin, sAdmin} = this.state;
			
			return(
					
				<div className="modal_usuarios">
				{checkAdmin &&
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				}
					<Alert stack={{limit: 3}} html={true} />
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
						
					
						<form method="POST" action="" onSubmit={this.handleSubmit}>
						
						
							<h4>Editar Usuario</h4>							
							<hr/>
							<div className="form-group">
								<label htmlFor="">Nombre del empleado</label>
								<input type="text" name="" placeholder="Nombre del empleado" className="form-control" required autoComplete="off"								
								ref={input => {this.nombreUsuario=input;}}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Correo</label>
								<input type="text" name="" placeholder="Correo" className="form-control" required autoComplete="off"
								ref={input => {this.correoUsuario=input;}}								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Contraseña</label>
								<input type="password" name="" placeholder="Contraseña" className="form-control" required autoComplete="off"
								ref={input => {this.passwordUsuario=input;}}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Confirmar Contraseña</label>
								<input type="password" name="" placeholder="Confirmar Contraseña" className="form-control" required autoComplete="off"
								ref={input => {this.confpasswordUsuario=input;}}								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Perfil</label>
								<select className="form-control"  
								ref={input => {this.perfilUsuario=input;}}
								>
									{this.state.perfiles.map(this.MakeItems)}
									
								</select>
							</div>
							{checkAdmin &&
							<div class="form-check" style={{marginBottom:10}}>
								<input name="sAdmin" className="form-check-input" type="checkbox" checked={sAdmin} onChange={this.handleInputChange} />
								<label className="form-check-label" htmlFor="defaultCheck1">
								Super Admin
								</label>
								<br></br>
                        	</div>
							}
							{sAdmin &&
								<div className="form-group">
									<label htmlFor="">Contraseña Administrador</label>
									<input type="password" name="" placeholder="Contraseña" className="form-control" required autoComplete="off"
									ref={input => {this.passwordAdmin=input;}}
									/>
								</div>
							}
							<div className="form-group">
								<label htmlFor="">Estado</label>
								<select className="form-control"
								ref={input => {this.estadoUsuario=input;}}
								>
									<option value="Activo">Activo</option>
									<option value="Inactivo">Inactivo</option>
								</select>
							</div>							
							
						<input className="btn btn-primary buttons" type="submit" value='Guardar' />
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
					</Modal> 
					
					
				</div>
			
			);
			
			
			
		}
	
	
}


export default ModalUsuarios;




// WEBPACK FOOTER //
// ./src/Components/Usuarios/ModalUsuarios.js